import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { NHAPipesModule } from '@nha/pipes';
import { NHATabGroupComponent } from './tab-group.component';

@NgModule({
	imports: [CommonModule, RouterModule, MatIconModule, MatTabsModule, NHAPipesModule, NHATabGroupComponent],
	exports: [NHATabGroupComponent]
})
export class NHATabGroupModule {}
